import React from 'react';
import { Link } from 'react-router-dom';

export default function Cookies() {
  return (
    <div className="bg-black pt-40 pb-32">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-5xl md:text-7xl font-serif font-bold mb-16 text-white">Cookie Policy</h1>
        <div className="prose prose-invert prose-zinc max-w-none space-y-10 text-zinc-400 text-base leading-relaxed">
          <section>
            <h2 className="text-2xl font-serif font-bold text-white mb-6">1. What Are Cookies?</h2>
            <p>
              Cookies are small text files placed on your computer or mobile device when you visit our website. They allow us to enhance website navigation, remember your preferences, and understand how visitors interact with our content.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-serif font-bold text-white mb-6">2. Types of Cookies We Use</h2>
            <ul className="space-y-4 list-disc pl-6">
              <li>
                <strong className="text-white">Strictly Necessary Cookies:</strong> Essential for website operation, security, and authentication within client and administrator portals.
              </li>
              <li>
                <strong className="text-white">Analytics & Performance Cookies:</strong> Help us measure visitor traffic and source referral channels (such as UTM parameters) to improve our communication and content quality.
              </li>
              <li>
                <strong className="text-white">Functional Cookies:</strong> Remember your preferences and interactive form inputs to prevent data loss during multi-step submissions.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-serif font-bold text-white mb-6">3. Managing Your Cookie Preferences</h2>
            <p>
              You can control and manage cookie settings directly in your web browser. Note that disabling certain essential cookies may affect the usability of interactive features such as multi-step forms and secure portal logins.
            </p>
          </section>

          <div className="pt-10 border-t border-zinc-900 flex justify-between items-center">
            <p className="text-sm italic text-zinc-600">Last updated: January 2025.</p>
            <Link to="/privacy" className="text-xs font-bold uppercase tracking-widest text-blue-500 hover:text-blue-400">View Privacy Policy &rarr;</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
